module.exports = __webpack_public_path__ + "media/images/icons/close-white-bc7ae846a6e30016013cdc717a59ae43.svg";